import React from 'react';
import { Card, CardContent } from '../components/ui/card';
import { testimonials } from '../mockData';
import { Quote } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
import SEO from '../components/SEO';

const Testimonials = () => {
  const { t } = useLanguage();
  
  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-50 to-white pt-24 pb-16">
      <SEO title="Real Testimonies from Our Prayer Delivery Service" description="Read heartfelt testimonies from believers whose prayer requests were carried to Jerusalem's holy sites — the Western Wall, Church of the Holy Sepulchre, Via Dolorosa and more. Real stories, real faith, real photos." path="/testimonials" />
      {/* Hero Section */}
      <div className="relative h-96 mb-16"
        style={{
          backgroundImage: 'url(https://images.unsplash.com/photo-1740761027004-d607726d6636)',
          backgroundSize: 'cover',
          backgroundPosition: 'center'
        }}
      >
        <div className="absolute inset-0 bg-gradient-to-r from-amber-900/90 to-amber-900/60" />
        <div className="relative z-10 container mx-auto px-4 h-full flex items-center">
          <div className="max-w-3xl">
            <h1 className="text-5xl md:text-6xl font-bold text-white mb-4">
              {t('testimonials.title')}
            </h1>
            <p className="text-xl text-gray-200">
              {t('testimonials.subtitle')}
            </p>
          </div>
        </div>
      </div>

      <div className="container mx-auto px-4">
        <div className="max-w-6xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {testimonials.map((testimonial) => (
              <Card key={testimonial.id} className="bg-white hover:shadow-xl transition-all">
                <CardContent className="p-8">
                  <div className="relative h-64 mb-6 rounded-lg overflow-hidden">
                    <img
                      src={testimonial.image}
                      alt={testimonial.site}
                      className="w-full h-full object-cover"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent" />
                    <div className="absolute bottom-4 left-4">
                      <div className="text-amber-400 text-sm font-medium">{testimonial.site}</div>
                    </div>
                  </div>
                  
                  <Quote className="text-amber-600 mb-4" size={32} />
                  <p className="text-gray-700 text-lg mb-6 italic leading-relaxed">
                    "{testimonial.message}"
                  </p>
                  
                  <div className="flex items-center justify-between pt-4 border-t border-gray-200">
                    <div>
                      <p className="font-bold text-gray-900 text-lg">{testimonial.name}</p>
                      <p className="text-sm text-gray-600">{testimonial.location}</p>
                    </div>
                  </div>
                </CardContent>
              </Card>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Testimonials;
